import {CreatePrivateResourceAccessGrant, PrivateResourceId} from "platformed-client/types";
import {platformedClient} from ".";
import {invalidateQueries, q} from "../state";

export async function get(privateId: PrivateResourceId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/private_resources/{private_id}", {
    path: {private_id: privateId},
  });
}

export async function deleteAndMakePublic(privateId: PrivateResourceId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/private_resources/{private_id}", {
    path: {private_id: privateId},
  });
  await invalidateQueries([q.tprm.thirdParties.filter(), q.tprm.thirdParty.filter()]);
  return res;
}

export async function updateAccessGrants(
  privateId: PrivateResourceId,
  accessGrants: CreatePrivateResourceAccessGrant[],
) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/private_resources/{private_id}/access_grants",
    {path: {private_id: privateId}, body: accessGrants},
  );
  await invalidateQueries([q.privateResource.filter(privateId)]);

  return res;
}
